// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.impersonation-banner,
.session-expired {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  height: var(--impersonation-banner-height, 44px);
  padding: 0 12px;
  color: white;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.impersonation-banner {
  background: linear-gradient(45deg, #ff6b6b, #ffa500);
  z-index: 9999;
}

.session-expired {
  background: #dc3545;
  z-index: 10000;
}

.banner-content,
.expired-content {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  max-width: 1200px;
  margin: 0 auto;
  gap: 8px;
}

.warning-icon,
.expired-icon {
  flex: none;
  font-size: 16px;
  line-height: 1;
}

.banner-text,
.expired-text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.separator {
  margin: 0 6px;
  opacity: 0.8;
}

.end-btn,
.redirect-btn {
  flex: none;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
}
.end-btn:hover,
.redirect-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/app/components/impersonation-banner/impersonation-banner.component.scss"],"names":[],"mappings":"AAIA;;EAEE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,gDAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;AAHF;;AAMA;EACE,oDAAA;EACA,aAAA;AAHF;;AAMA;EACE,mBAAA;EACA,cAAA;AAHF;;AAMA;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;AAHF;;AAMA;;EAEE,UAAA;EACA,eAAA;EACA,cAAA;AAHF;;AAMA;;EAEE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,YAAA;AAHF;;AAMA;;EAEE,UAAA;EACA,oCAAA;EACA,0CAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAHF;AAKE;;EACE,oCAAA;AAFJ","sourcesContent":["// The banner is a fixed strip at the very top of <ion-app>. global.scss pushes\n// the split pane down by --impersonation-banner-height so nothing underneath is\n// covered, which only holds if the banner really is that tall: keep it a\n// single, non-wrapping line and let the text truncate rather than grow.\n.impersonation-banner,\n.session-expired {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n  height: var(--impersonation-banner-height, 44px);\n  padding: 0 12px;\n  color: white;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.impersonation-banner {\n  background: linear-gradient(45deg, #ff6b6b, #ffa500);\n  z-index: 9999;\n}\n\n.session-expired {\n  background: #dc3545;\n  z-index: 10000;\n}\n\n.banner-content,\n.expired-content {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  max-width: 1200px;\n  margin: 0 auto;\n  gap: 8px;\n}\n\n.warning-icon,\n.expired-icon {\n  flex: none;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.banner-text,\n.expired-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.separator {\n  margin: 0 6px;\n  opacity: 0.8;\n}\n\n.end-btn,\n.redirect-btn {\n  flex: none;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n  white-space: nowrap;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
